import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  title: PropTypes.string.isRequired,
  width: PropTypes.number,
  children: PropTypes.any,
};

export default function InstructionsCard({title, width = 4, children}) {
  return <div className={'col-md-' + width + ' instructions-card-wrapper'}>
    <div className='instructions-card'>
      <div className='instructions-card-header'>
        <h3>{title}</h3>
        <div className='clearfix' />
      </div>
      <div className='instructions-card-body'>{children}</div>
    </div>
  </div>;
}

InstructionsCard.propTypes = propTypes;
